import React, { useEffect, useRef, useState } from "react";
import psychologyImage from "../img/Поиск-себя.png";
import educationImage from "../img/Управление-проектами.png";
import productionImage from "../img/Соц-проектирование.png";
import { DirectionCard } from "../utils/DirectionCard";

export const About = () => {
  const directions = [
    {
      title: "Психология",
      description: "Помогаем разобраться в себе, наладить отношения и обрести гармонию.",
      image: psychologyImage,
      anchor: "#services",
    },
    {
      title: "Образование",
      description: "Современные подходы к обучению и развитию навыков в разных сферах.",
      image: educationImage,
      anchor: "#portfolio",
    },
    {
      title: "Продакшн",
      description: "Создание качественного арт-контента: от идеи до реализации.",
      image: productionImage,
      anchor: "#testimonials",
    },
  ];

  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting) {
            setVisibleCards((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      cardRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const handleCardClick = (anchor) => {
    const target = document.querySelector(anchor);
    if (target) {
      window.scrollTo({
        top: target.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>Наши направления</h2>
        </div>
        <div className="card-grid">
          {directions.map((item, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              data-index={index}
              onClick={() => handleCardClick(item.anchor)}
              className={`card-wrapper ${visibleCards.includes(index) ? "fade-in-up" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <DirectionCard
                title={item.title}
                description={item.description}
                image={item.image}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
